export * from './onboarding-start/onboarding-start.component';
export * from './onboarding-details/onboarding-details.component';
